import React from 'react';
import {connect as withFormik, getIn} from 'formik';
import {EnhancedTextInput} from '../library/FormControls/EnhancedTextInput';

const FormikTextInput = ({field, form, ...rest}) => {
  const {name} = field;
  const {errors = {}, touched = {}, initialValues, setFieldValue} = form;
  const initialValue = getIn(initialValues, name);

  const clearField = () => {
    setFieldValue(name, initialValue);
  };

  return (
    <EnhancedTextInput
      name={name}
      error={getIn(errors, name)}
      touched={getIn(touched, name)}
      onClear={clearField}
      value={initialValue}
      {...field}
      {...rest}
    />
  );
};

export default withFormik(FormikTextInput);



// WEBPACK FOOTER //
// ./src/reactModules/shared/LeadForm/FormikTextInput.js